module.exports = __webpack_public_path__ + "static/media/logo.e0a210c1.png";